import { render, staticRenderFns } from "./AvatarSection.vue?vue&type=template&id=93001a52&scoped=true&"
import script from "./AvatarSection.vue?vue&type=script&lang=js&"
export * from "./AvatarSection.vue?vue&type=script&lang=js&"
import style0 from "./AvatarSection.vue?vue&type=style&index=0&id=93001a52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93001a52",
  null
  
)

export default component.exports